/**
 * RightSidebar — 데스크탑 전용 우측 사이드바 (#406 위젯 영역)
 * - 코인 시세 위젯 (환율/날씨는 API 키 발급 후 추가 예정)
 * - 모바일 미노출 (hidden md:flex)
 * (기존 광고주 목록은 #406 으로 폐기)
 */

import CryptoWidget from "./CryptoWidget";
import ExchangeWidget from "./ExchangeWidget";
import WeatherWidget from "./WeatherWidget";

export default function RightSidebar() {
  return (
    <aside
      className="hidden md:flex shrink-0 flex-col w-[230px] border-l border-slate-200 bg-white overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]"
      aria-label="widgets"
    >
      {/* 위젯 콘텐츠 전체 왼쪽 5px 이동 */}
      <div className="-translate-x-[5px]">
        <WeatherWidget />
        <ExchangeWidget />
        <CryptoWidget />
      </div>
    </aside>
  );
}
